'use strict';

var novicell = novicell || {};

novicell.search = novicell.search || new function () {

    var body = document.querySelector('#site');
    var searchInput = document.querySelector('.search-overlay-input-container__input');
    var searchOverlay = document.querySelector('#js-search-overlay');

    this.init = function () {
        var searchButton = document.querySelector('#js-search-overlay-trigger');

        if (!searchButton) {
            return;
        }
        // Open search overlay
        searchButton.addEventListener('click', clickSearchButton);
    };

    function clickSearchButton(e) {
        e.preventDefault();

        closeOverlayHandler();
        body.classList.add('search-overlay-open');
        searchInput.focus();
    }

    function closeOverlayHandler() {
        document.addEventListener('keydown', handleEsc, true);
        document.addEventListener('click', handleClick, true);
    }

    function closeSearchOverlay() {
        body.classList.remove('search-overlay-open');
        searchInput.blur();
        searchInput.value = '';
        document.removeEventListener('keydown', handleEsc, true);
        document.removeEventListener('click', handleClick, true);
    }

    function handleEsc(e) {
        if (e.keyCode === 27) {
            closeSearchOverlay();
        }
    }

    function handleClick(e) {
        var targetElement = e.target;
        do {
            if (targetElement == searchOverlay) {
                // This is a click inside. Do nothing, just return.
                return;
            }
            targetElement = targetElement.parentNode;
        } while (targetElement);

        // This is a click outside.
        closeSearchOverlay();
    }
}();
